module.exports = __webpack_public_path__ + "static/media/dtj-color-mock-2.c3876b96.jpg";